var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('Menu'),_c('div',{staticClass:"main-panel"},[_c('Head'),_c('div',{staticClass:"content py-0"},[_vm._t("body")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }